import { useDispatch } from "react-redux";
import { useApiClient } from "../../useApiClient";
import { useAuthUser } from "../../useLogin";

export const useRequestProfileAccess = (toUserId) => {
  const { apiClient } = useApiClient();
  const dispatch = useDispatch();
  const userInfo = useAuthUser();

  const requestProfileAccess = (serviceRequestId, onResult) => {
    dispatch({ type: "SET_LOADING", value: true });
    apiClient
      .post("/pending-actions/profile-access-request-action", {
        profileUserId: toUserId,
        requestorUserId: userInfo.userId,
        serviceRequestId: serviceRequestId,
      })
      .then((res) => {
        onResult && onResult(res);
      })
      .catch((error) => {
        console.error(error);
      })
      .then(function () {
        dispatch({ type: "SET_LOADING", value: false });
      });
  };

  return {
    requestProfileAccess,
  };
};
